import axios from "axios";
import defaultURL from "./config";

const instance = axios.create({
    baseURL: `${defaultURL}/api`,
    withCredentials: true,
});

export default instance;
